import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function UserSearch({ reportFilters, setReportFilters }) {
  const { t } = useTranslation();

  return (
    <div className="px-4 mb-6">
      {' '}
      {/* px-4 = left & right padding */}
      <div className="relative">
        {/* Search Icon */}
        <Search className="absolute w-5 h-5 text-gray-400 transform -translate-y-1/2 left-3 top-1/2" />

        {/* Search Input */}
        <input
          type="text"
          value={reportFilters.search}
          onChange={(e) =>
            setReportFilters((prev) => ({ ...prev, search: e.target.value }))
          }
          placeholder={t('Search by Officer, Contact, Role or Department...')}
          className="w-full py-3 pl-10 pr-4 text-sm placeholder-gray-400 transition-colors border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>
    </div>
  );
}
